import { render, staticRenderFns } from "./AssignmentStitcher.vue?vue&type=template&id=13872601&"
import script from "./AssignmentStitcher.vue?vue&type=script&lang=js&"
export * from "./AssignmentStitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports